// removed by extract-text-webpack-plugin
module.exports = {"base":"Header_base--wZiCK","base__victory":"Header_base__victory--RxiM3","baseVictory":"Header_base__victory--RxiM3","base__defeat":"Header_base__defeat--3dX6f","baseDefeat":"Header_base__defeat--3dX6f","base__draw":"Header_base__draw--3JIWa","baseDraw":"Header_base__draw--3JIWa","outcome":"Header_outcome--2QYhK","title":"Header_title--25QdW","outcomeMessage":"Header_outcomeMessage--34YNo","reward":"Header_reward--1QdK2","earnedResource":"Header_earnedResource--8Bu31"};


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Header/Header.scss
// module id = 535
// module chunks = 11 14